import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AppCSS from '../../../utils/styled';

export const Components = {
  LinkContainer: styled(Link)<{ hasTopSeparator?: boolean; $isCollapsed?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: ${(p) => (p.$isCollapsed ? 'center' : 'flex-start')};
    text-decoration: none;
    margin-bottom: 16px;
    ${(p) => !p.hasTopSeparator && `margin-top: ${16}px;`};
    ${(p) => p.hasTopSeparator && `padding-top: ${16}px;`};
    width: 100%;
    ${(p) => p.hasTopSeparator && `border-top: 1px solid ${AppCSS.colors.greys.light};`};
    &:focus-visible {
      outline: 2px solid ${AppCSS.colors.blues.primary};
      outline-offset: 2px;
      ${AppCSS.radiuses.default};
    }
  `,
  IconWrapper: styled.div<{ active?: boolean; $isCollapsed?: boolean }>`
    margin-right: ${(p) => (p.$isCollapsed ? 0 : 12)}px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: ${(p) => (!!p.active ? AppCSS.colors.white : 'transparent')};
    ${AppCSS.radiuses.default};
    transition: background-color 0.15s ease;
    a:hover > & {
      background-color: ${(p) => (p.active ? AppCSS.colors.white : 'rgba(255, 255, 255, 0.12)')};
    }
  `,
  LinkText: styled.span<{ active?: boolean }>`
    ${({ active }) => (active ? AppCSS.fonts.label14Medium : AppCSS.fonts.label14Regular)};
    color: ${AppCSS.colors.white};
  `,
};
